$(function() {

	$('input#error-search').keyup(function(e) {
		if($(this).val() === "") {
			$(this).parent().find('label').removeClass('label-pop-out');
			$('.clear-field').css({'opacity':'0'});
		} else {
			$(this).parent().find('label').addClass('label-pop-out');
			$('.clear-field').css({'opacity':'1'});
		}

		var code = e.keyCode || e.which;
		if(code == 13) {
			helper.search($(this).val());
			e.preventDefault();
			return false;
		}

	});

	if($('input#error-search').val() !== "") {
		$("input#error-search").parent().find('label').addClass('label-pop-out');
		$('.clear-field').css({'opacity':'1'});
	}


	$('.search-form').submit(function(e) {
		e.preventDefault();
		return false;
	});

	$('.clear-field').click(function(e) {
		$(this).parent().find('label').removeClass('label-pop-out');
		$('#error-search').val('');
		$('.clear-field').css({'opacity':'0'});
	});

});



//////////////////
// WEBPACK FOOTER
// ./public/js/error-page.js
// module id = 70
// module chunks = 0